import { Input } from "shared/ui/Input";
import styles from "./SearchInput.module.scss";

export const SearchInput = ({ onDisabled }) => {
  return (
    <div className={styles.searchContainer}>
      <Input
        type="text"
        placeholder="Поиск"
        className={styles.searchInput}
        onClick={onDisabled}
        readonly={true}
      />
    </div>
  );
};
